<div class="info-dialog-container">
  <div *ngIf="data?.img">
    <img [src]="data?.img" alt="icon" class="icon">
  </div>
  <div class="fs-lg" style="font-weight: 400">
    {{ data.text }}
  </div>
  <div class="title-f">
    {{ data.textBold }}
  </div>
</div>
<button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
